import styled from 'styled-components';
const Divider = styled.hr.withConfig({ displayName: "brc-Divider", componentId: "brc-78lteq" }) `
  border-radius: 4px;
  border: none;
  height: 8px;
  background-color: ${({ theme }) => theme.neutral100};
  margin: 0;
`;
export default Divider;
//# sourceMappingURL=divider.js.map